import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class AplicationStateService {

  public language = 'hu';
  public filterHistory: any[] = [];
  public navLevel = 0;
  public categoryNameSlugMap: Map<any, any> = new Map<any, any>();

  constructor() {}

}
